<template>
  <div class="app-container d-flex flex-column min-vh-100">
    <NavBar @toggle-sidebar="toggleSidebar" class="fixed-top" />
    
    <div class="wrapper d-flex flex-grow-1">
      <SideBar :is-collapsed="sidebarCollapsed" />
      
      <main :class="['main-content flex-grow-1 p-3', { 'collapsed': sidebarCollapsed }]">
        <h2 class="mb-3"><slot name="title"></slot></h2>
        <slot></slot>
      </main>
    </div>
    
    <FooterBar class="fixed-bottom" />
  </div>
</template>

<script>
import NavBar from './NavBar.vue'
import SideBar from './SideBar.vue'
import FooterBar from './FooterBar.vue'

export default {
  name: 'AppTemplate',
  components: {
    NavBar,
    SideBar,
    FooterBar
  },
  data() {
    return {
      sidebarCollapsed: false
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed
    }
  }
}
</script>

<style scoped>
.app-container {
  background-color: #f8f9fa;
  padding-top: 56px; /* Hauteur de la navbar */
  padding-bottom: 56px; /* Hauteur du footer */
}

.wrapper {
  display: flex;
  position: relative;
  overflow: hidden;
}

.main-content {
  transition: all 0.3s ease;
  background-color: #fff;
  margin-left: 250px;
  width: calc(100% - 250px);
  overflow-y: auto; /* Permet le scroll uniquement ici */
  height: calc(100vh - 56px - 56px); /* 100vh - navbar - footer */
}

.main-content.collapsed {
  margin-left: 80px;
  width: calc(100% - 80px);
}

@media (max-width: 992px) {
  .main-content {
    margin-left: 0 !important;
    width: 100% !important;
  }
  
  .sidebar {
    z-index: 1040; /* Au-dessus de la navbar */
  }
}
</style>